import React, { useState } from "react"
import { Skeleton, Typography, MenuItem, CardHeader, Card, CardContent, CardMedia } from '@mui/material'
import MenuBar from '../../ui/menuBar/MenuBar'
import SparklineGraph from "../../Graphs/SparklineGraph"
import { marginToPaddingStyles } from '../../Graphs/graphUtils'
import dashboardStyles from '../../../pages/Dashboard.module.scss'
import { formatPrice, formatPercent } from '../../../utils/tools'
import useProject from "../hooks/useProject"
import { useGeneral } from "../../../context/general"
import './Project.css'

const graphMargin = {top: 16, bottom: 16, right: 16, left: 8}
const skeletonPadding = marginToPaddingStyles(graphMargin)

export default function Project({ ticker, name, uuid, updated_at,currency_code, handleCreateProjectAndOpen }) {
    const [anchorEl, setAnchorEl] = useState(null)
    const { sparkline } = useProject(ticker)
    const { projectMethods } = useGeneral()

    const onClick = () => handleCreateProjectAndOpen(ticker)

    const handleWatchlistProject = (e) => {
        e.stopPropagation()
        projectMethods.toggleWatchlist(uuid)
        setAnchorEl(null)
    }

    const menuItems = () => {
        return [
            <MenuItem key={`watchlist-${uuid}`} onClick={handleWatchlistProject}>
                { projectMethods.getWatchlistStatus(uuid).action }   
            </MenuItem>
        ]
    }

    return (
        <Card className={`projectCard ${dashboardStyles['card']}`} onClick={uuid && onClick} >
            <CardHeader
                className="projectCard-header"
                action={
                    <MenuBar setAnchorEl={setAnchorEl} anchorEl={anchorEl} menuId={`project-options-${name}`}>
                         {menuItems()}
                    </MenuBar>
                }
            />
            <CardContent className="projectCard-content">
                <div>
                    <Typography variant="overline" className="projectCard--light">
                        {new Date(updated_at).toLocaleDateString()}
                    </Typography>
                    <Typography variant="h3">
                            {ticker}
                    </Typography>
                </div>
                <div className="projectCard-numbers">
                    <Typography variant="h2" className="projectCard-price" >
                        {sparkline?.lastPrice
                            ? new Intl.NumberFormat('en-US', { style: 'currency', currency: currency_code }).format(sparkline.lastPrice)
                            : <Skeleton variant="text" width="3em" />
                        }
                    </Typography>
                    <Typography className={`projectCard-price ${sparkline?.diffPrecent < 0 ? 'down' : 'up'}`}>
                    {sparkline
                        ? `${formatPrice(sparkline.diff,'always','en-US',currency_code)}
                        (${formatPercent(sparkline.diffPrecent)})`
                        : <Skeleton variant="text" width="5em" />
                    }
                    </Typography>
                </div>
            </CardContent>
            <CardMedia className="projectCard-graph">
                {sparkline?.data
                    ? <SparklineGraph graph={[sparkline]} margin={graphMargin} />
                    : <div style={skeletonPadding}>
                        <Skeleton variant="rect" width="100%" height="100%" />
                    </div>
                }
            </CardMedia>
        </Card>
    )
}